function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.15,
    height: 17.5,
    viewBox: "0 0 16.15 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10551"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40920",
    d: "M3 6h14.4",
    transform: "translate(-2 -2.05)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#6c7c8c",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40921",
    d: "M16.2 5.2v11.2a1.6 1.6 0 0 1-1.6 1.6h-8A1.6 1.6 0 0 1 5 16.4V5.2m2.4 0V3.6A1.6 1.6 0 0 1 9 2h3.2a1.6 1.6 0 0 1 1.6 1.6v1.6",
    transform: "translate(-2.4 -1.25)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#6c7c8c",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 23",
    transform: "translate(6.6 7.95)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#6c7c8c",
      fill: "none"
    },
    d: "M0 0v4.8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 24",
    transform: "translate(9.8 7.95)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#6c7c8c",
      fill: "none"
    },
    d: "M0 0v4.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.04b4988ebf981cade4190c57d4fe80eb.svg";
export { ForwardRef as ReactComponent };